import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';

import { catchError, map } from 'rxjs/operators';

import { Observable, of } from 'rxjs';

import { CreditEarlyRepaymentGuardPopupService } from '../../credit-early-repayment-guard-popup/credit-early-repayment-guard-popup.service';
import {
  CreditEarlyRepaymentPaymentType,
  CreditEarlyRepaymentStatus,
  CreditEarlyRepaymentStatusPaymentStatus,
} from '../../credit-early-repayment-guard-popup/credit-early-repayment-quard-popup.model';

import { CreditPartialPaymentWizardService } from './../credit-partial-payment-wizard.service';

@Injectable({providedIn: 'root'})
export class CreditPartialPaymentGuard implements CanActivate {

	constructor(
		private creditEarlyRepaymentGuardPopupService: CreditEarlyRepaymentGuardPopupService,
		private creditPartialPaymentWizardService: CreditPartialPaymentWizardService,
	) { }

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.creditPartialPaymentWizardService.getIsEarlyPartRepaymentAvailable(route.params['id'])
			.pipe(
				map((paymentStatusData: CreditEarlyRepaymentStatus) => {
					if (paymentStatusData.paymentStatus !== CreditEarlyRepaymentStatusPaymentStatus.SUCCESS) {
						this.creditEarlyRepaymentGuardPopupService.openEarlyRepaymentPopup(
							paymentStatusData,
							CreditEarlyRepaymentPaymentType.PARTIAL,
						);
						return false;
					}

					return true;
				}),
				catchError(() => {
					this.creditEarlyRepaymentGuardPopupService.openEarlyRepaymentPopup(undefined, undefined);
					return of(false);
				}),
			);
	}

}
